module.exports = __webpack_public_path__ + "static/media/train_61.d72924b9.jpg";